export default __webpack_public_path__ + "static/media/Brain-01.9fe63dd1.svg";